import type {TikTokCommentTiktokTriggerStruct} from '@cohort/shared/apps/tiktok/triggers/commentTiktok';
import type {ActionCtaComponentProps} from '@cohort/wallet/apps/TriggerIntegration';
import OpenCtaUnverified from '@cohort/wallet/components/challenges/OpenCtaUnverified';
import {useTranslation} from 'react-i18next';

const TikTokCommentTiktokTriggerActionCtaComponent: React.FC<
  ActionCtaComponentProps<TikTokCommentTiktokTriggerStruct>
> = ({config, processStepVerification, trackingMetadata}) => {
  const {t} = useTranslation('app-tiktok', {
    keyPrefix: 'triggers.comment-tiktok',
  });

  return (
    <OpenCtaUnverified
      url={config.url}
      ctaTitle={t('ctaTitle')}
      processStepVerification={processStepVerification}
      trackingMetadata={trackingMetadata}
    />
  );
};

export default TikTokCommentTiktokTriggerActionCtaComponent;
